import * as signalR from "@microsoft/signalr";
import { AppConfig } from "../AppConfig";
import { getAGEToken } from "./authenticate";
const URL = AppConfig.NFSAPI.BaseApiUrl + "nfshub";
class Connector {
    public connection: signalR.HubConnection;
    static instance: Connector;
    public status: boolean = true;
    constructor(userId: string) {
        const urlWithUserId = `${URL}?userId=${encodeURIComponent(userId)}`; // websocket does not support custom headers, so we pass userId as query param
        this.connection = new signalR.HubConnectionBuilder()
            .withUrl(urlWithUserId, { accessTokenFactory: getAGEToken })
            .withAutomaticReconnect()
            .build();
        this.connection.start().catch((err) => {
            console.log(err);
            this.status = false;
        });
    }
    public static getInstance(userId: string): Connector {
        if (!Connector.instance) Connector.instance = new Connector(userId);
        return Connector.instance;
    }
}

export default Connector.getInstance;
